var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7476,
    height: 5039,
    viewBox: "0 0 7476 5039",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7475.86,
    height: 4798.38,
    rx: 383,
    fill: "white",
    fillOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_176_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5915.93 4370.68H2976.43V4382.95H5915.93V4370.68Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5367.35 2284.16C5373.01 2290.59 5377.21 2298.11 5379.68 2306.21C5382.14 2314.32 5382.83 2322.83 5381.68 2331.21C5380.53 2339.58 5377.57 2347.63 5373.01 2354.83C5368.44 2362.04 5362.36 2368.23 5355.16 2373.01L5050.95 2575.15L4916.99 2661.58C4909.38 2666.49 4900.15 2668.48 4891.11 2667.17C4882.07 2665.86 4873.85 2661.34 4868.06 2654.49C4864.68 2650.5 4862.24 2645.84 4860.91 2640.85C4859.57 2635.85 4859.37 2630.64 4860.32 2625.56C4861.28 2620.48 4863.36 2615.67 4866.42 2611.44C4869.48 2607.22 4873.46 2603.69 4878.07 2601.1L5007.81 2528.19L5234.25 2319.47L5088.69 2168.16L5196.51 2089.89L5367.35 2284.16Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4651.98 4187.47H4577.57L4533.37 3592.63L4722.07 3587.41L4651.98 4187.47Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4657.37 4380.53C4637.53 4389.3 4620.91 4318.29 4604.17 4334.21C4557.36 4378.73 4485.67 4388.43 4423.18 4368.99L4445.05 4368.75C4441.28 4367.58 4437.79 4365.68 4434.8 4363.16C4431.81 4360.65 4429.38 4357.57 4427.66 4354.12C4425.93 4350.67 4424.95 4346.92 4424.77 4343.09C4424.59 4339.26 4425.21 4335.43 4426.6 4331.84C4428.27 4327.55 4430.98 4323.71 4434.52 4320.65C4438.06 4317.6 4442.31 4315.42 4446.91 4314.31L4496.69 4302.26L4574.87 4169.21L4654.68 4163.99C4672.47 4185.94 4684.88 4211.51 4690.99 4238.78C4697.1 4266.04 4696.74 4294.3 4689.94 4321.41C4682.7 4350.01 4671.52 4374.28 4657.37 4380.53Z",
    fill: "url(#paint0_linear_176_9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5147.46 4187.47H5073.04L5028.85 3592.63L5222.94 3556.11L5147.46 4187.47Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5152.85 4380.53C5133.01 4389.3 5116.39 4318.29 5099.65 4334.21C5052.84 4378.73 4981.15 4388.43 4918.66 4368.99L4940.53 4368.75C4936.76 4367.58 4933.27 4365.68 4930.28 4363.16C4927.29 4360.65 4924.86 4357.57 4923.14 4354.12C4921.41 4350.67 4920.43 4346.92 4920.25 4343.09C4920.07 4339.26 4920.69 4335.43 4922.08 4331.84C4923.74 4327.55 4926.46 4323.71 4930 4320.65C4933.54 4317.6 4937.79 4315.42 4942.38 4314.31L4992.17 4302.26L5070.35 4169.21L5155.55 4158.77L5157.7 4162.18C5174.17 4187.87 5184.79 4216.66 5188.85 4246.64C5192.91 4276.62 5190.31 4307.09 5181.24 4336.02C5174.15 4357.99 5164.51 4375.38 5152.85 4380.53Z",
    fill: "url(#paint1_linear_176_9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5231.84 2103.34C5163.4 2112.56 5116.03 2148.83 5096.73 2221.18L4970.94 1996.41C4963.48 1982.13 4961.59 1965.72 4965.62 1950.2C4969.64 1934.67 4979.31 1921.07 4992.86 1911.89C5007.23 1902.14 5024.91 1898.08 5042.28 1900.54C5059.65 1903 5075.38 1911.79 5086.27 1925.12L5231.84 2103.34Z",
    fill: "url(#paint2_linear_176_9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5363.65 3530.02C5057.81 3660.98 4744.81 3677.1 4425.54 3592.63C4542.13 3155.02 4679.79 2759.32 4678.94 2434.27L4991.64 2408.18L5039.79 2482.05C5154.02 2657.32 5232.87 2851.96 5272.16 3055.67L5363.65 3530.02Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4851.46 1761.16C4940.79 1761.16 5013.21 1691.08 5013.21 1604.63C5013.21 1518.17 4940.79 1448.09 4851.46 1448.09C4762.14 1448.09 4689.72 1518.17 4689.72 1604.63C4689.72 1691.08 4762.14 1761.16 4851.46 1761.16Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5029.38 1881.17L4829.9 1891.61L4797.55 1719.42L4959.29 1693.33L5029.38 1881.17Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5007.81 2434.27L4789.27 2440.23L4678.94 2455.14C4624.78 2281.99 4579.18 2109.25 4689.72 1964.66L4819.12 1839.43L5013.21 1834.21L5015.78 1835.63C5046.6 1852.73 5070.49 1879.47 5083.51 1911.46C5096.52 1943.45 5097.89 1978.77 5087.39 2011.62C5039.22 2163.1 5008.28 2306.14 5007.81 2434.27Z",
    fill: "url(#paint3_linear_176_9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4673.55 2919.53L4659.99 3098.83C4659.26 3108.44 4654.98 3117.46 4647.92 3124.25C4640.86 3131.04 4631.51 3135.13 4621.58 3135.77C4615.86 3136.14 4610.12 3135.35 4604.73 3133.45C4599.34 3131.56 4594.42 3128.6 4590.28 3124.76C4586.14 3120.92 4582.87 3116.29 4580.69 3111.16C4578.5 3106.03 4577.44 3100.52 4577.58 3094.97L4581.89 2919.53L4716.68 2423.83L4722.07 2121.19L4873.03 2115.98L4862.25 2465.57L4673.55 2919.53Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4889.2 2142.07C4825.2 2116.88 4765.42 2125.31 4711.29 2178.59L4718.7 1923.07C4719.64 1907.09 4726.49 1891.97 4738.01 1880.48C4749.52 1869 4764.93 1861.91 4781.4 1860.53C4798.89 1859.05 4816.3 1864.11 4830.06 1874.66C4843.82 1885.2 4852.89 1900.44 4855.41 1917.25L4889.2 2142.07Z",
    fill: "url(#paint4_linear_176_9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5193.82 2301.21H4697.81C4813.52 2004.67 4850.83 1728.8 4697.81 1492.44C4700.44 1421.45 4794.52 1359.91 4867.58 1366.71C4953.87 1374.74 5069.83 1436.11 5085.99 1518.53L5193.82 2301.21Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3613.05 1353.67H3590.43V753.849C3590.43 708.259 3581.15 663.116 3563.12 620.996C3545.1 578.876 3518.67 540.605 3485.37 508.368C3452.06 476.131 3412.51 450.56 3368.99 433.113C3325.47 415.667 3278.83 406.687 3231.72 406.688H1918.64C1871.54 406.687 1824.89 415.667 1781.37 433.113C1737.85 450.56 1698.31 476.132 1665 508.369C1631.69 540.606 1605.26 578.876 1587.24 620.996C1569.21 663.116 1559.93 708.259 1559.93 753.849V4044.53C1559.93 4090.12 1569.21 4135.26 1587.24 4177.38C1605.26 4219.5 1631.69 4257.77 1665 4290.01C1698.31 4322.24 1737.85 4347.81 1781.37 4365.26C1824.89 4382.71 1871.54 4391.69 1918.64 4391.69H3231.72C3278.83 4391.69 3325.47 4382.71 3368.99 4365.26C3412.51 4347.81 3452.06 4322.24 3485.37 4290.01C3518.67 4257.77 3545.1 4219.5 3563.12 4177.38C3581.15 4135.26 3590.43 4090.12 3590.43 4044.53V1780.64H3613.05V1353.67Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3246.19 497.008H3074.79C3082.68 515.71 3085.68 536.002 3083.55 556.095C3081.42 576.188 3074.22 595.466 3062.58 612.231C3050.94 628.995 3035.22 642.732 3016.8 652.23C2998.38 661.728 2977.83 666.697 2956.96 666.699H2204.71C2183.84 666.697 2163.29 661.728 2144.88 652.23C2126.46 642.732 2110.73 628.995 2099.09 612.231C2087.45 595.466 2080.25 576.188 2078.12 556.095C2075.99 536.002 2079 515.71 2086.88 497.008H1926.79C1891.61 497.008 1856.78 503.714 1824.28 516.742C1791.78 529.771 1762.25 548.868 1737.37 572.942C1712.5 597.016 1692.77 625.596 1679.3 657.051C1665.84 688.505 1658.91 722.218 1658.91 756.264V4042.11C1658.91 4076.16 1665.84 4109.87 1679.3 4141.33C1692.77 4172.78 1712.5 4201.36 1737.37 4225.43C1762.25 4249.51 1791.78 4268.61 1824.28 4281.63C1856.78 4294.66 1891.61 4301.37 1926.79 4301.37H3246.19C3281.37 4301.37 3316.21 4294.66 3348.71 4281.63C3381.21 4268.61 3410.74 4249.51 3435.61 4225.43C3460.49 4201.36 3480.22 4172.78 3493.68 4141.33C3507.14 4109.87 3514.07 4076.16 3514.07 4042.11V756.264C3514.07 687.505 3485.85 621.562 3435.61 572.942C3385.38 524.322 3317.24 497.008 3246.19 497.008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3282.39 1010.28H1890.6V2165.63H3282.39V1010.28Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2303.61 2406.55C2359.85 2406.55 2405.45 2362.42 2405.45 2307.99C2405.45 2253.56 2359.85 2209.43 2303.61 2209.43C2247.36 2209.43 2201.77 2253.56 2201.77 2307.99C2201.77 2362.42 2247.36 2406.55 2303.61 2406.55Z",
    fill: "url(#paint5_linear_176_9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2354.53 2299.78H2312.1V2258.71H2295.12V2299.78H2252.69V2316.2H2295.12V2357.27H2312.1V2316.2H2354.53V2299.78Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2841.09 2406.55C2897.33 2406.55 2942.93 2362.42 2942.93 2307.99C2942.93 2253.56 2897.33 2209.43 2841.09 2209.43C2784.85 2209.43 2739.25 2253.56 2739.25 2307.99C2739.25 2362.42 2784.85 2406.55 2841.09 2406.55Z",
    fill: "url(#paint6_linear_176_9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2892.01 2316.2V2299.78H2790.17V2316.2H2892.01Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2638.4 1154.37H2528.41C2524.55 1154.37 2520.84 1155.85 2518.1 1158.5C2515.37 1161.15 2513.83 1164.74 2513.83 1168.48V1215.2C2513.83 1218.95 2515.37 1222.53 2518.1 1225.18C2520.84 1227.83 2524.55 1229.31 2528.41 1229.31H2546.64V1299.32H2620.17V1229.31H2638.4C2642.27 1229.31 2645.98 1227.83 2648.71 1225.18C2651.45 1222.53 2652.98 1218.95 2652.98 1215.2V1168.48C2652.98 1164.74 2651.45 1161.15 2648.71 1158.5C2645.98 1155.85 2642.27 1154.37 2638.4 1154.37Z",
    fill: "#676363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2748.57 1581.97C2681.21 1486.58 2646.77 1373 2650.19 1257.51C2650.25 1254.85 2649.36 1252.24 2647.66 1250.14C2645.97 1248.04 2643.57 1246.58 2640.88 1245.99V1225.8H2524.72V1245.71H2523.12C2521.56 1245.71 2520.01 1246.01 2518.56 1246.6C2517.12 1247.18 2515.8 1248.03 2514.7 1249.1C2513.59 1250.17 2512.72 1251.45 2512.12 1252.85C2511.52 1254.25 2511.22 1255.75 2511.22 1257.26C2511.22 1257.54 2511.23 1257.82 2511.25 1258.1C2520.4 1381.56 2489.5 1492.28 2418.55 1590.25C2414.46 1595.88 2412.38 1602.64 2412.6 1609.52L2425.3 1989.77C2425.61 1998.25 2429.29 2006.29 2435.57 2012.21C2441.85 2018.13 2450.25 2021.47 2459.02 2021.54H2721.76C2730.63 2021.47 2739.12 2018.05 2745.42 2012.01C2751.72 2005.97 2755.34 1997.79 2755.5 1989.21L2760.4 1620.02C2760.54 1606.47 2756.41 1593.19 2748.57 1581.97Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M2615.47 1169.59C2615.47 1177.67 2612.16 1185.41 2606.26 1191.12C2600.36 1196.83 2592.36 1200.04 2584.01 1200.04C2575.67 1200.04 2567.67 1196.83 2561.77 1191.12C2555.87 1185.41 2552.55 1177.67 2552.55 1169.59",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2706.97 1708.28H2675.16C2672.12 1689.21 2662.13 1671.81 2646.99 1659.25C2631.85 1646.68 2612.57 1639.77 2592.63 1639.77C2572.68 1639.77 2553.4 1646.68 2538.26 1659.25C2523.13 1671.81 2513.13 1689.21 2510.1 1708.28H2478.28C2474.89 1708.28 2471.55 1708.99 2468.47 1710.36C2465.4 1711.73 2462.66 1713.72 2460.46 1716.21C2458.26 1718.69 2456.63 1721.61 2455.7 1724.76C2454.77 1727.91 2454.56 1731.22 2455.07 1734.46L2489.63 1951.86H2688.07L2730.05 1735.19C2730.69 1731.91 2730.57 1728.53 2729.7 1725.3C2728.83 1722.07 2727.24 1719.06 2725.04 1716.49C2722.84 1713.92 2720.08 1711.85 2716.95 1710.44C2713.83 1709.02 2710.42 1708.28 2706.97 1708.28Z",
    fill: "url(#paint7_linear_176_9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3282.39 2636.52H1890.6V3791.87H3282.39V2636.52Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2303.61 4032.79C2359.85 4032.79 2405.45 3988.67 2405.45 3934.23C2405.45 3879.8 2359.85 3835.67 2303.61 3835.67C2247.36 3835.67 2201.77 3879.8 2201.77 3934.23C2201.77 3988.67 2247.36 4032.79 2303.61 4032.79Z",
    fill: "url(#paint8_linear_176_9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2354.53 3926.02H2312.1V3884.96H2295.12V3926.02H2252.69V3942.45H2295.12V3983.52H2312.1V3942.45H2354.53V3926.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2841.09 4032.79C2897.33 4032.79 2942.93 3988.67 2942.93 3934.23C2942.93 3879.8 2897.33 3835.67 2841.09 3835.67C2784.85 3835.67 2739.25 3879.8 2739.25 3934.23C2739.25 3988.67 2784.85 4032.79 2841.09 4032.79Z",
    fill: "url(#paint9_linear_176_9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2892.01 3942.45V3926.02H2790.17V3942.45H2892.01Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2860.48 3457.3L2861.25 3457.3C2887.46 3457.51 2913.12 3450.08 2934.89 3435.96C2956.66 3421.85 2973.54 3401.71 2983.31 3378.18C3014.09 3302.84 3021.3 3220.4 3004.03 3141.13C2986.77 3061.85 2945.79 2989.24 2886.19 2932.34C2826.6 2875.45 2751.03 2836.77 2668.9 2821.13C2586.76 2805.49 2501.68 2813.58 2424.26 2844.39C2346.84 2875.2 2280.49 2927.37 2233.48 2994.4C2186.47 3061.44 2160.87 3140.37 2159.88 3221.38C2158.88 3302.39 2182.52 3381.9 2227.87 3450C2273.22 3518.1 2338.26 3571.79 2414.9 3604.37C2438.72 3614.58 2465.17 3617.58 2490.79 3612.99C2516.4 3608.39 2539.98 3596.41 2558.44 3578.61C2598.02 3540.1 2645.09 3509.56 2696.93 3488.74C2748.77 3467.91 2804.36 3457.23 2860.48 3457.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2641.29 3332.29C2719.11 3332.29 2782.2 3271.23 2782.2 3195.92C2782.2 3120.6 2719.11 3059.54 2641.29 3059.54C2563.47 3059.54 2500.38 3120.6 2500.38 3195.92C2500.38 3271.23 2563.47 3332.29 2641.29 3332.29Z",
    fill: "#F9A825"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_176_9",
    x1: 4559.25,
    y1: 4163.99,
    x2: 4559.25,
    y2: 4381.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB96FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_176_9",
    x1: 5054.68,
    y1: 4158.77,
    x2: 5054.68,
    y2: 4381.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB96FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_176_9",
    x1: 5097.69,
    y1: 1899.84,
    x2: 5097.69,
    y2: 2221.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB96FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_176_9",
    x1: 4858.14,
    y1: 1834.21,
    x2: 4858.14,
    y2: 2455.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB96FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_176_9",
    x1: 4800.24,
    y1: 1860.28,
    x2: 4800.24,
    y2: 2178.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB96FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_176_9",
    x1: 2303.61,
    y1: 2209.43,
    x2: 2303.61,
    y2: 2406.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB96FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_176_9",
    x1: 2841.09,
    y1: 2209.43,
    x2: 2841.09,
    y2: 2406.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB96FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_176_9",
    x1: 2592.63,
    y1: 1639.77,
    x2: 2592.63,
    y2: 1951.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB96FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_176_9",
    x1: 2303.61,
    y1: 3835.67,
    x2: 2303.61,
    y2: 4032.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB96FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_176_9",
    x1: 2841.09,
    y1: 3835.67,
    x2: 2841.09,
    y2: 4032.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB96FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B00FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_176_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4356,
    height: 3985,
    fill: "white",
    transform: "translate(1559.93 406.688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.8ba441b96e636428a52003f17fa4f6aa.svg";
export { ForwardRef as ReactComponent };